export default __webpack_public_path__ + "static/media/Rolling.200d71a6.gif";